import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack, go } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';
const url = 'venta';

const LOADER_VENTA = 'LOADER_VENTA';
const SET_DATA_VENTA = 'SET_DATA_VENTA';
const SET_PAGE_VENTA = 'SET_PAGE_VENTA';
const SET_UPDATE_DATA_VENTA ='SET_UPDATE_DATA_VENTA';
const SET_BUSCADOR_VENTA = 'SET_BUSCADOR_VENTA';
const SET_FILTRO_VENTA = 'SET_FILTRO_VENTA';
const SET_TOGGLEMODAL_VENTA = 'SET_TOGGLEMODAL_VENTA';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_VENTA, cargando: true});
    const store = getStore();
    const search = store.venta.buscador;
    const filtro = store.venta.filtro_venta;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_VENTA, cargando: false});
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_VENTA, data});
            dispatch({type: SET_PAGE_VENTA, page});
        }
        dispatch({type: LOADER_VENTA, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_VENTA, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_VENTA, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/'))
        }
    }).then((data) => {
        dispatch({type: LOADER_VENTA, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_VENTA, updateData: data});
            dispatch(initializeForm('bodega', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.bodega.values;
    dispatch({type: LOADER_VENTA, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_VENTA, cargando: false})
        Swal('Éxito', 'Se ha creado la bodega.', 'success')
        .then(() => {
            dispatch(push('/'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_VENTA, cargando: false})
        Swal(
            'Error',
             (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_BODEGA, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.bodega.values);
    dispatch({type: LOADER_VENTA, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_VENTA, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_VENTA, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.anulacion.values);
    dispatch({type: LOADER_VENTA, cargando: true});
    api.post(`${url}/anular/${id}`, formData).then((data) => {
        dispatch({type: LOADER_VENTA, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(closeModal());
                dispatch(go(-1));
            })
    }).catch((error) => {
        dispatch({type: LOADER_VENTA, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(closeModal());
                dispatch(go(-1));
        })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_VENTA, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_VENTA, filtro_venta: filtro});
    dispatch(listar(1));
};
const openModal = () => (dispatch, getStore) => {
    dispatch({
        type: SET_TOGGLEMODAL_VENTA,
        toggleModal: true
    })
}
const closeModal = () => (dispatch, getStore) => {
    dispatch({
        type: SET_TOGGLEMODAL_VENTA,
        toggleModal: false
    })
}
const regresar = () => (dispatch, getStore) =>  {
    dispatch(go(-1));
}
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro,
    regresar,
    closeModal,
    openModal
};
export const reducer = {
    [LOADER_VENTA]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_VENTA]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_VENTA]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_VENTA]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_VENTA]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_VENTA]: (state, { filtro_venta }) => {
        return {...state, filtro_venta }
    },
    [SET_TOGGLEMODAL_VENTA]: (state, { toggleModal }) => {
        return {...state, toggleModal }
    }
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_venta: null,
    updateData: {},
    toggleModal: false
};
export default handleActions(reducer, initialState)
